<template>
  <div class="tile-pattern">
    <div class="row">
      <div class="col-sm-3 tile-item" v-for="(pattern, index) in patterns" :key="index">
        <div class="tc-tile" @click="patternSelect(pattern)">
          <object type="image/svg+xml" :data="pattern.svg" class="pattern" :class="{active: currentPattern && pattern.name === currentPattern.name}"></object>
          <div class="tc-tile-name">{{pattern.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'TilePattern',
  data: function(){

    return {
    }

  },
  computed: {
    currentPattern(){
        return this.$store.state.pattern;
    },
    patterns(){
        return this.$store.state.patterns;
    }
  },
  methods: {
      patternSelect(pattern){
          this.$store.commit('setPattern', pattern);
      },
      ready(){
          for(let key in this.currentPattern) {
              if(this.currentPattern.hasOwnProperty(key)){
                  this.$emit('ready', true);

                  return;
              }
          }
      }
  },
  watch: {
      currentPattern(){
          this.ready();
      }
  },
  mounted(){

      let vm = this;

      Vue.nextTick()
          .then(function () {
              vm.ready();
          })

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .tc-tile:hover{
    cursor: pointer;
  }

  .tc-tile-name{
    text-align: center;
  }

  .pattern{
    width: 100%;
    pointer-events: none;
    border: 5px solid transparent;
    transition: border-color 0.5s ease-in-out;

    &.active{
      border-color: cornflowerblue;
    }
  }
</style>
